import React, { useState, useEffect } from 'react';
import './OrderTrackingModal.css';

const OrderTrackingModal = ({ order, onClose }) => {
  const statusSequence = [
    { status: 'Packaging', class: 'status-packaging-track' },
    { status: 'Shipped', class: 'status-shipped-track' },
    { status: 'Out for Delivery', class: 'status-out-for-delivery-track' },
    { status: 'Delivered', class: 'status-delivered-track' }
  ];

  const [currentStatus, setCurrentStatus] = useState('');

  useEffect(() => {
    setCurrentStatus(order.status);
  }, [order]);

  const getProgressPercentage = () => {
    const statusIndex = statusSequence.findIndex(item => item.status === currentStatus);
    return (statusIndex / (statusSequence.length - 1)) * 100;
  };

  return (
    <div className="order-tracking-modal-overlay">
      <div className="order-tracking-modal-content">
        <button className="order-tracking-close-btn" onClick={onClose}>
          &times;
        </button>
        
        <p className="order-tracking-title">Tracking Order: {order.name}</p>

        <div className="progress-bar-container">
          <div 
            className="progress-bar" 
            style={{ width: `${getProgressPercentage()}%` }}
          ></div>
        </div>

        <div className="order-status-line">
          {statusSequence.map((item, index) => (
            <div
              key={index}
              className={`order-status-item ${item.class} ${currentStatus === item.status ? 'active' : ''}`}
            >
              <span className="status-text">{item.status}</span>
            </div>
          ))}
        </div>

        <div className="order-details">
          <p><strong>Order ID:</strong> {order.id}</p>
          <p><strong>Vendor:</strong> {order.vendorName}</p>
          <p><strong>Booking Date:</strong> {order.bookingDate}</p>
        </div>

        <div className="location-history">
          <h3>Location History</h3>
          {order.locations.map((location, index) => (
            <div key={index} className="location-item">
              <span><strong>Location:</strong> {location.location}</span><br></br>
              <span><strong>Date:</strong> {location.date}</span>
            </div>
          ))}
        </div>

        <div className="action-buttons">
          <button className="download-invoice-btn">Download Invoice</button>
          <button className="download-test-reports-btn">Download Test Reports</button>
          <button className="other-action-btn">Other Actions</button>
        </div>
      </div>
    </div>
  );
};

export default OrderTrackingModal;
